@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/breakpoints/breakpoints' as *;

.singleFileRoot {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-start;
}

.singleFileRootEditable {
  composes: singleFileRoot;
  justify-content: space-between;
}

.mainContent {
  display: flex;
  align-items: center;
  gap: 8px;
}

.previewWrapper {
  position: relative;
}

.iconWrapper {
  width: 100%;
}

.greyOverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(1, 1, 1, 50%);
}

.spinnerWrapper {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 50%);
}

.fileInfoWrapper {
  display: flex;
  flex-direction: column;

  span {
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @include respond-to('max-sm') {
    max-width: 85%;

    span {
      width: 170px;
    }
  }
}

.styledImage {
  width: 32px;
  height: 32px;
}

.styledImageFaded {
  composes: styledImage;
  opacity: 0.5;
}

.fileName {
  @include typography-v2-body-sm;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fileNameUploading {
  composes: fileName;
  color: var(--text-soft);
}

.fileNameComplete {
  composes: fileName;
  color: var(--text-default);
}

.fileNameError {
  composes: fileName;
  color: var(--text-disabled);
}

.fileSize {
  @include typography-v2-body-sm;
}

.fileSizeUploading {
  composes: fileSize;
  color: var(--text-soft);
}

.fileSizeComplete {
  composes: fileSize;
  color: var(--text-default);
}

.fileSizeError {
  composes: fileSize;
  color: var(--text-critical);
}

.errorMessage {
  @include typography-v2-body-sm;
  color: var(--text-critical);

  &::before {
    content: '•';
    margin: 0 4px;
  }
}

.styledIcon {
  cursor: pointer;
}

.styledErrorIcon {
  position: absolute;
  top: 0;
  right: 0;
}
